import YudlButton from "../Button";

const NotFound = () => {
  return (
    <div style={{ display: "grid", placeItems: "center", height: "calc(100vh - 200px)" }}>
      <div className="display-3">Oops !!! You Seem lost</div>
      <YudlButton buttonRole="link" children="Go Back" link="/" />
    </div>
  );
};

export default NotFound;
